// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".5068c15ac50b3bcbd299d69c531003b924979d71.chunk.bundle.js";
};